/*
 * This file is part of BlueMap, licensed under the MIT License (MIT).
 *
 * Copyright (c) Blue (Lukas Rieger) <https://bluecolored.de>
 * Copyright (c) contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
import $ from 'jquery';

import Dropdown from "./Dropdown";

export default class MapSelection extends Dropdown {
	constructor(bluemap) {
		super(undefined);
		super.onChange = this.onChangeMap;

		this.bluemap = bluemap;

		//add maps
		const maps = this.bluemap.settings.maps;
		for (let mapId of this.bluemap.maps) {
			const map = maps[mapId];
			if (!map.enabled) continue;

			this.addOption(mapId, map.name);
		}

		$(document).on('bluemap-map-change', this.onBlueMapMapChange);
	}

	createElement() {
		let element = super.createElement();
		element.addClass("map-selection");
		return element;
	}

	onChangeMap = value => {
		this.bluemap.changeMap(value);
	};

	onBlueMapMapChange = () => {
		this.select(this.bluemap.map);
	};
}
